import { useEffect, useRef } from "react";
import { isAppLayout } from "@/lib/native";

// Save handlers close directly; dismiss/navigation paths go through this guard.
export function useNativeDraft(open, value) {
  const initial = useRef(null);
  const wasOpen = useRef(false);
  const serialized = JSON.stringify(value);
  if (open && !wasOpen.current) initial.current = serialized;
  wasOpen.current = open;
  const dirty = open && initial.current !== serialized;
  useEffect(() => {
    if (!isAppLayout() || !dirty) return;
    const guard = (event) => {
      if (
        !event.defaultPrevented &&
        !window.confirm("Discard unsaved changes?")
      )
        event.preventDefault();
    };
    const unload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("native-before-navigate", guard);
    window.addEventListener("beforeunload", unload);
    return () => {
      window.removeEventListener("native-before-navigate", guard);
      window.removeEventListener("beforeunload", unload);
    };
  }, [dirty]);
  const dismiss = (callback) => {
    if (!isAppLayout() || !dirty || window.confirm("Discard unsaved changes?"))
      callback();
  };
  dismiss.markSaved = (nextValue = value) => {
    initial.current = JSON.stringify(nextValue);
  };
  return dismiss;
}

export function allowNativeNavigation() {
  return window.dispatchEvent(
    new Event("native-before-navigate", { cancelable: true }),
  );
}
